import { map } from 'nanostores';
import { debounce } from '../utils/tickers';

export const $screen = map({
    width: window.innerWidth,
    height: window.innerHeight
});

export const $screenDebounce = map({
    width: window.innerWidth,
    height: window.innerHeight
});

window.addEventListener('resize', () => {
    $screen.setKey('width', window.innerWidth);
    $screen.setKey('height', window.innerHeight);
});

const debouncedFunction = () => {
    $screenDebounce.setKey('width', window.innerWidth);
    $screenDebounce.setKey('height', window.innerHeight);
};

window.addEventListener('resize', debounce(debouncedFunction, 200));
